import {APP_LOGO_BLUE_PATH, APP_LOGO_BLUE_NY_PATH} from 'constants/images';

const getLogo = () => {
    const date = new Date();
    const month = date.getMonth();
    const day = date.getDate();
    if (month === 11 && day >= 15 || month === 0 && day <= 15) {
        return APP_LOGO_BLUE_NY_PATH;
    }
    return APP_LOGO_BLUE_PATH;
};

export const imageUtils = {
    getLogo
};